import * as Yup from 'yup';

export default Yup.object().shape({
  notCausedByCountyError: Yup.string(),
  paidInFull: Yup.string(),
  doesNotExceed2500: Yup.string(),
  penaltyDueToFailure: Yup.string(),
  noPenaltyPriorThreeYears: Yup.string(),
});
